import { z } from 'zod'
import { type ChatMessagePayload } from '#app/services/ai/types.ts'

export const SupportedCountry = {
	CostaRica: 'CR',
	Panama: 'PA',
	Colombia: 'CO',
} as const

export type SupportedCountry = (typeof SupportedCountry)[keyof typeof SupportedCountry]

export const SupportedCountrySchema = z.enum([SupportedCountry.CostaRica, SupportedCountry.Panama, SupportedCountry.Colombia])

export function parseSupportedCountry(value: unknown): SupportedCountry {
	const result = SupportedCountrySchema.safeParse(value)
	return result.success ? result.data : SupportedCountry.CostaRica
}

export type CountryChatResponse = {
	responseText: string
	payloads: ChatMessagePayload
	promptUsed: string
	promptTokens: number
	textTokens: number
	noIntention?: boolean
}

export type SourceUpdaterStrategy = 'date-range' | 'id-cursor' | 'custom'

export type SourceUpdaterDefinition = {
	strategy: SourceUpdaterStrategy
	run: (params: unknown) => Promise<unknown>
}
